// App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import HomeCarousel from "./components/HomeCarousel";
import FloatingChatWidget from "./components/FloatingChatWidget";
import AboutUs from "./pages/AboutUs";
import TopBrands from "./pages/TopBrands";
import StoreLocator from "./pages/StoreLocator";
import TopBrandsSlider from "./components/TopBrandsSlider";
import ECatalogue from "./pages/E-Catalogue";
import CustomerSupport from "./pages/CustomerSupport";
import ComingSoon from "./pages/ComingSoon";
import CategoryCarousel from "./components/CategoryCarousel";
import CategoryPage from "./pages/CategoryPage";
import ProductAdmin from "./pages/ProductAdmin";
import { ProductsProvider } from "./components/ProductsContext";
import CategorySlider from "./components/CategorySlider"; 
import WhyChooseUs from "./components/WhyChooseUs";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import "./App.css";

function App() {
 const CDN_BASE = "https://cdn.greateastern.in/GETCO/";

const topCategories = [
  {
    name: "Airconditioner",
    bannerWeb: `${CDN_BASE}Untitled_design_2_rjcex6.png`,
    bannerMobile: `${CDN_BASE}phone_Cat_1_lgqfj9.png`,
  },
  {
    name: "Washing machines",
    bannerWeb: `${CDN_BASE}Copy_of_Untitled_kfwpxz.png`,
    bannerMobile: `${CDN_BASE}Copy_of_Copy_of_Copy_of_phone_Cat_djqbod.png`,
  },
  {
    name: "Televisions",
    bannerWeb: `${CDN_BASE}Copy_of_Copy_of_Untitled_exzkix.png`,
    bannerMobile: `${CDN_BASE}Copy_of_phone_Cat_qxilu3.png`,
  },
  {
    name: "Refrigerators",
    bannerWeb: `${CDN_BASE}Copy_of_Copy_of_Copy_of_Untitled_m9efd9.png`,
    bannerMobile: `${CDN_BASE}Copy_of_Copy_of_phone_Cat_ap86pv.png`,
  },
  {
    name: "Mobiles",
    bannerWeb: `${CDN_BASE}Copy_of_Copy_of_Copy_of_Copy_of_Untitled_y14nnp.png`,
    bannerMobile: `${CDN_BASE}phone_Cat_2_qnxk0n.png`,
  },
];




  return (
    <ProductsProvider>
    <Router>
      <div className="app-container">
        <Header />

        <main className="main-content">
          <Routes>
            <Route
              path="/"
              element={
                <>
                  <HomeCarousel />
                  
                  <CategoryCarousel />
                   <h2 className="top-brands-slider-heading">Top Categories</h2>
                  {/* ✅ Show top category sliders on homepage */}
                  {topCategories.map((cat) => (
                  <CategorySlider
                    key={cat.name}
                   categoryName={cat.name}
                   bannerWeb={cat.bannerWeb}
                   bannerMobile={cat.bannerMobile}
                   />
                  ))}
                  <WhyChooseUs />
                  <TopBrandsSlider />
                </>
              }
            />

            <Route path="/aboutus" element={<AboutUs />} />
            <Route path="/topbrands" element={<TopBrands />} />
            <Route path="/storelocator" element={<StoreLocator />} />
            <Route path="/ecatalogue" element={<ECatalogue />} />
            <Route path="/customersupport" element={<CustomerSupport />} />
            <Route path="/comingsoon" element={<ComingSoon />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/category/:categoryName" element={<CategoryPage />} />

            {/* Add more routes as needed */}
          </Routes>
        </main>

        <Footer />
        <FloatingChatWidget />
      </div>
    </Router>
    </ProductsProvider>
  );
}

export default App;
